import { Turbo } from "@hotwired/turbo-rails";

import { showFlashToast } from "../utils/flash_toast";

Turbo.StreamActions.flash_toast = function flashToast() {
  const template = this.templateElement?.content;
  if (!template) {
    return;
  }

  const payload = template.querySelector("[data-flash-type]");
  const type = payload?.getAttribute("data-flash-type") || "success";
  const message = payload?.textContent?.trim() || template.textContent?.trim();

  if (!message) {
    return;
  }

  const variant = type === "error" ? "danger" : type;
  showFlashToast({ type: variant, message });
};
